module.exports = "/_next/static/images/img__card-4-touch-d76403cf90dee1e7c3a8d4834c69eb00.png";